import { createSlice } from '@reduxjs/toolkit';
import { AppConfigsState } from './app-configs.state';

const initialState: AppConfigsState = {
    values: {
        isBuiltInMode: false,
        keepSessionAlive: false,
    },
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const appConfigsSlice = createSlice({
    name: 'appConfigs',
    initialState,
    reducers: {
        setIsBuiltInMode(state, action) {
            const id = action.payload;
            state.values.isBuiltInMode = id;
        },
        setKeepSessionAlive(state, action) {
            state.values.keepSessionAlive = action.payload;
        },
    },
});

export const { setIsBuiltInMode, setKeepSessionAlive } =
    appConfigsSlice.actions;
export default appConfigsSlice.reducer;
